import SeriesDetails from './SeriesDetails';

export default SeriesDetails;
